document.documentElement.classList.add('nh-js');
